var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3324 6.92859C6.1044 6.92859 5.8867 6.83859 5.72642 6.67745L0.5846 1.53475C0.249469 1.19962 0.249469 0.657066 0.5846 0.322791C0.919731 -0.0123415 1.46143 -0.0123415 1.79656 0.322791L6.3324 4.85951L10.8699 0.322791C11.2051 -0.0123415 11.7468 -0.0123415 12.0819 0.322791C12.417 0.657923 12.417 1.19962 12.0819 1.53475L6.93837 6.67745C6.77809 6.83859 6.56039 6.92859 6.3324 6.92859Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClosed);
export default __webpack_public_path__ + "static/media/ArrowClosed.c3a09862369b2027cdcbfb4149014bc7.svg";
export { ForwardRef as ReactComponent };